module.exports = __webpack_public_path__ + "img/up.dcf2a51a.png";